import { Decamelized } from 'humps';

interface CorpDinerSettings {
  allocationsPermitted?: boolean;
  ssoUniqueIdentifier: string;
  sentWelcomeEmail?: string | null;
}

export enum ROLES {
  DINER = 'CORP_DINER',
  ADMIN = 'CORP_ADMIN',
  FINANCIAL_ADMIN = 'CORP_ADMIN_AND_FINANCIAL_ADMIN',
  CORP_PARENT_ADMIN = 'CORP_PARENT_ADMIN',
}

export interface Employee {
  id?: string;
  corpTags?: string[];
  role: ROLES;
  roles?: string[];
  lastName: string;
  firstName: string;
  uri?: string;
  corpDinerSettings: CorpDinerSettings;
  locationId?: string;
  departmentId?: string;
  email: string;
  internalId: string;
  phoneNumber: string;
  allocationsPermitted?: boolean;
  ssoUniqueIdentifier?: string;
  subDepartment?: string;
}

export type EmployeeResponse = Decamelized<Employee>;

export interface CreateEmployeeResponse {
  id: string;
  alreadyExists: boolean;
  uri: string;
}

export type EmployeeSearchResultItem = {
  id: string;
  dinerId: string;
  firstName: string;
  lastName: string;
  email: string;
  role: ROLES;
};

export type EmployeeSearchResultItemResponse =
  Decamelized<EmployeeSearchResultItem>;
